import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { InventoryManagerFormAtomProps } from "../InventoryManagerForm.types";

import styles from "../InventoryManagerForm.module.scss";

const PasswordFields = ({ control }: InventoryManagerFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.form_twoInputsBlock}>
      <Controller
        control={control}
        name="password"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Password")}
            placeholder={t("Enter Password")}
            isPassword
            errorMessage={error?.message}
            data-testid="inventory-manager--password"
          />
        )}
      />

      <Controller
        control={control}
        name="repeatPassword"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Repeat Password")}
            placeholder={t("Enter Password")}
            isPassword
            errorMessage={error?.message}
            data-testid="inventory-manager--repeatPassword"
          />
        )}
      />
    </div>
  );
};
export default PasswordFields;
